import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Tabs, Tab, Button, Form } from 'react-bootstrap';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear, faPencil } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import trash from "../../../../assets/images/trash.png";
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import View from "../../../../assets/images/view.png";
import { withRFSToken } from '../../../../Services/axios';
import XLSFILE from '../../../../assets/Import_template.xls';
import { toast } from 'react-toastify';
import { Link , useHistory } from 'react-router-dom';
import Select from 'react-select';
import * as XLSX from 'xlsx';

import DownloadGrid from '../../common/DownloadGrid.js';

import ActivityComments from '../../../../Components/common/ActivityComments.js';  
import ImageUpload from '../Components/Common/ImageUpload.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';


const RecordImport = () => {
    const isMounted = useRef(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const [activeTab, setActiveTab] = useState('Active');
    const [resetFilter, setResetFilter] = useState(false);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
        Nvwa: useRef(null),
    };
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else if (tab == 'Archived') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        } else if (tab == 'Nvwa') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Nvwa: {} });
            }, 1);
        }
    };

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedRowDetails, setSelectedRowDetails] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationInfo, setConfirmationInfo] = useState('');
    const [deleteFunction, setDeleteFunction] = useState(null);
    const [deleteId, setDeleteId] = useState('');

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const tabType = activeTab === 'Active' ? 'Active' : activeTab === 'Archived' ? 'Archived' : activeTab === 'Nvwa' ? 'NVWA' : undefined;
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'cargohub_id', type: 'string' },
                    { name: 'customer_name', type: 'string' },
                    { name: 'job_nr', type: 'string' },
                    { name: 'hawb', type: 'string' },
                    { name: 'master_airwaybill', type: 'string' },
                    { name: 'shipper', type: 'string' },
                    { name: 'shipper_name', type: 'string' },
                    { name: 'consignee', type: 'string' },
                    { name: 'consignee_name', type: 'string' },
                    { name: 'setting_status', type: 'string' },
                    { name: 'setting_department', type: 'string' },
                    { name: 'updated_on', type: 'string' },
                    { name: 'updated_user', type: 'string' },
                    { name: 'inspection_date', type: 'string' },
                    { name: 'inpsection_time', type: 'string' },
                    { name: 'is_invoice', type: 'string' },
                    { name: 'invoice_amount', type: 'string' },
                    { name: 'invoice_currency', type: 'string' },

                    //nvwa
                    { name: 'fills_nvwa', type: 'string' },
                    { name: 'inspection_conf_time', type: 'string' },
                    { name: 'inspection_confirm', type: 'string' },
                    { name: 'inspection_req_time', type: 'string' },
                    { name: 'inspection_center', type: 'string' },
                    { name: 'master_airwaybill', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'country_code', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'arrival_date', type: 'string' },
                    { name: 'no_of_fytos', type: 'string' },
                    { name: 'inspection_start_time', type: 'string' },
                    { name: 'type_of_goods', type: 'string' },
                    { name: 'e_pcs', type: 'string' },
                    { name: 'e_weight', type: 'string' },
                    { name: 'customer_name', type: 'string' },
                    { name: 'inspection_remarks', type: 'string' }
                ],
                // id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}shipment/import-shipment-record-list?tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns = [];
            if (activeTab == 'Active' || activeTab == 'Archived') {
                columns = [
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + View + '" class="row_edit" /></div>';
                        },
                        width: '5%', filterable: false,
                    },
                    { text: 'ID', filtertype: 'input', datafield: 'cargohub_id', width: '8%', cellclassname: '', },
                    // { text: 'Job No.', filtertype: 'textbox', datafield: 'job_nr', width: '8%', cellclassname: '', },
                    {
                        text: "Invoice Status", datafield: "is_invoice", width: "6%",
                        filtertype: 'checkedlist',
                        filteritems: [
                            { label: 'Yes', value: 'Yes' },
                            { label: 'No', value: 'No' },
                        ],
                        cellclassname: (row, column, value, rowData, cellvalue) => {
                            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
                            if (rowData.is_invoice == "No") {
                                return "awb_orange";
                            } else if (rowData.is_invoice == "Yes") {
                                return "awb_green";
                            } else {
                                return;
                            }
                        },
                    },
                    { text: 'Job No.', filtertype: 'input', datafield: 'job_nr', width: '7%', cellclassname: '', },
                    { text: 'Currency', filtertype: 'input', datafield: 'invoice_currency', width: '5%', cellclassname: '', },
                    { text: 'TTL Amount', filtertype: 'input', datafield: 'invoice_amount', width: '6%', cellclassname: '', },
                    { text: 'HAWB', filtertype: 'input', datafield: 'hawb', width: '7%', cellclassname: '', },
                    { text: 'MAWB', filtertype: 'input', datafield: 'master_airwaybill', width: '7%', cellclassname: '', },
                    { text: 'Customer', filtertype: 'input', datafield: 'customer_name', width: '8%', cellclassname: '', },
                    { text: 'Shipper', filtertype: 'input', datafield: 'shipper', width: '7%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            let displayValue = (rowdata?.shipper)
                                ? rowdata?.shipper
                                : (rowdata?.shipper_name?.awb_shp_name)
                                    ? rowdata.shipper_name.awb_shp_name
                                    : "";

                            return "<div class='jqx-grid-cell-left-align' style='margin-top:13px;margin-left:10px'>" + displayValue+ "</div>";
                        } 
                    },
                     { text: 'Consignee', filtertype: 'input', datafield: 'consignee', width: '7%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            let displayValue = (rowdata?.consignee)
                                ? rowdata?.consignee
                                : (rowdata?.consignee_name?.awb_shp_name)
                                    ? rowdata.consignee_name.awb_shp_name
                                    : "";

                            return "<div class='jqx-grid-cell-left-align' style='margin-top:13px;margin-left:10px'>" + displayValue+ "</div>";
                        } 
                    },
                    {
                        text: 'Status', filtertype: 'input', datafield: 'setting_status', width: '6%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            // console.log('cellValue', rowdata);
                            if (rowdata?.setting_status) {
                                // console.log('cellValue', rowdata);

                                return "<div class='jqx-grid-cell-left-align' style='margin-top:13px;margin-left:10px'>" + rowdata.setting_status.name + "</div>";
                            }
                        },
                    },
                    {
                        text: 'Department', filtertype: 'input', datafield: 'setting_department', width: '8%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            // console.log('cellValue', rowdata);
                            if (rowdata?.setting_department) {
                                // console.log('cellValue', rowdata);

                                return "<div class='jqx-grid-cell-left-align' style='margin-top:13px;margin-left:10px'>" + rowdata.setting_department.name + "</div>";
                            }
                        },
                    },
                    { text: 'Update On', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'updated_on', width: '8%', cellclassname: '', },
                    {
                        text: 'Last update By', filtertype: 'inpuinput', datafield: 'updated_user', width: '8%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata, cellValue) {
                            // console.log('cellValue', rowdata);
                            if (rowdata?.updated_user) {
                                // console.log('cellValue', rowdata);

                                return "<div class='jqx-grid-cell-left-align' style='margin-top:13px;margin-left:10px'>" + rowdata.updated_user.first_Name + ' ' + rowdata.updated_user.last_Name + "</div>";
                            }
                        },
                    },
                    // { text: 'Inspection Date & Time', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'inspection_date', width: '10%', cellclassname: '', },
                ];
            } else {
                columns = [
                    {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + View + '" class="row_edit" /></div>';
                    },
                    width: '4%', filterable: false,
                    },
                    // { text: 'Fills NVWA', filtertype: 'textbox', datafield: 'fills_nvwa', width: '4%', cellclassname: '' },
                    { text: 'Confirmation', filtertype: 'input', datafield: 'inspection_conf_time', width: '5%', cellclassname: '' },
                    { text: 'Inspection Center', filtertype: 'input', datafield: 'inspection_center', width: '7%', cellclassname: '' },
                    { text: 'MAWB number', filtertype: 'input', datafield: 'master_airwaybill', width: '7%', cellclassname: '' },
                    { text: 'Flight Number', filtertype: 'input', datafield: 'flight_number', width: '6%', cellclassname: '' },
                    // { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '4%', cellclassname: '' },
                    { text: 'Country', filtertype: 'input', datafield: 'country_code', width: '4%', cellclassname: '' },
                    { text: 'Destination', filtertype: 'input', datafield: 'destination', width: '5%', cellclassname: '' },
                    { text: 'Arrival Date', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'arrival_date', width: '8%', cellclassname: '' },
                    { text: 'No of Fyco', filtertype: 'input', datafield: 'no_of_fytos', width: '6%', cellclassname: '' },
                    { text: 'Req Inspection', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'inspection_date', width: '8%', cellclassname: '' },
                    { text: 'Nvwa Approval', filtertype: 'input', datafield: 'inspection_confirm', width: '6%', cellclassname: '' },
                    { text: 'Type of goods', filtertype: 'input', datafield: 'type_of_goods', width: '8%', cellclassname: '' },
                    { text: 'Exp Pcs', filtertype: 'input', datafield: 'e_pcs', width: '6%', cellclassname: '' },
                    { text: 'Exp Weight', filtertype: 'input', datafield: 'e_weight', width: '6%', cellclassname: '' },
                    { text: 'Customer', filtertype: 'input', datafield: 'customer_name', width: '7%', cellclassname: '' },
                    { text: 'Comments', filtertype: 'input', datafield: 'inspection_remarks', width: '10%', cellclassname: '' }
                ]
            }
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const innerData = rowData.id;
                        localStorage.removeItem('SHEdit');
                        // loadDetails(rowData.id);
                        localStorage.setItem('SHEdit', JSON.stringify(innerData));
                        localStorage.setItem('ccbackUrl', '/ForwarderShipments/ShipmentRecords');
                        localStorage.setItem('AddShipmentType', 'import');
                        history.push("/ForwarderShipments/AddShipmentRecords")
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');

                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const rowBookingId = rowData.booking_id;
                const rowBookingType = rowData.Type;
                // console.log("🚀 ~ rowBookingId:", rowData);
                setDeleteId(rowData.id);

                handleShowConfirmation(deleteRow);
                // Handle click for button 2
                console.log('Button 2 clicked');
            });
            // window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            //     console.log("🚀 ~ rowData:", rowData)
            //     setIsModal(true)
            // });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1 && event.args.columnindex !== 5) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails(args.id);
                    // setSelectedRowData(args)
                }
            });
           window.$(gridRefs[activeTab].current).on("celldoubleclick", function (event) {
            const args = event.args;
            console.log("args", args);
            
            // Check if the double-clicked column is HAWB or MAWB
            const datafield = args.datafield;
            if (datafield === 'hawb' || datafield === 'master_airwaybill' || datafield == "cargohub_id") {
                const cellValue = args.value;
                if (cellValue !== null && cellValue !== undefined && String(cellValue).trim() !== '') {
                    navigator.clipboard.writeText(String(cellValue))
                    .then(() => {
                        toast.success("Copied to clipboard: " + cellValue);
                    })
                    .catch(err => {
                        // optional error handling
                        // console.error("Failed to copy:", err);
                    });
                }
            }
});
        }
    }, [gridData]);

    const [editMode, setEditMode] = useState(false);
    const [userList, setUserList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [formData, setFormData] = useState({});

    const loadDetails = async (uldNumber) => {
        try {
            const res = await withRFSToken.post(`shipment/import-shipment-record-details/${uldNumber}`, {})
            // .then(function (res) {
            if (res.data.response_code == 200) {
                const innerData = res.data.response_data;
                console.log("🚀 ~ innerData:", innerData)
                setSelectedRowData(innerData);
                setEditMode(false)
                setFormData({
                    id: innerData?.id,
                    shipper: innerData?.shipper,
                    assigned_to: innerData?.assigned_to,
                    setting_status: innerData?.setting_status?.id,
                    setting_department: innerData?.setting_department?.id,
                })
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        fetchUser();
        fetchStatus();
        fetchDepartment();
    }
    const fetchUser = async () => {
        try {

            const res = await withRFSToken.get(`uld-setting/get-user-list`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.user_id,
                        label: item.first_name + ' ' + item.last_name,
                        email: item.email_id,
                    })) : [];
                    setUserList(transformedData);
                    // if (innerData.length > 0) {
                    // if (!edidId) {
                    //     const isDefault = innerData?.find(dflt => dflt.email_id == userId)
                    //     setFormData(prevFormData => ({ ...prevFormData, assigned_to: isDefault?.user_id }))
                    // } 
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStatus = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=export&type=S`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setStatusList(transformedData);
                    if (innerData.length > 0) {
                        const isDefault = innerData?.find(dflt => dflt.is_default === 1)
                        setFormData(prevFormData => ({ ...prevFormData, setting_status: isDefault.id }))
                    }
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDepartment = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=export&type=D`, {})
                .then(function (res) {

                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setDepartmentList(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const handleDetailsEdit = () => {
        setEditMode(true);
        // fetchUser();

    }
    const handleEditSubmit = async () => {
        setEditMode(false);
        try {
            const res = await withRFSToken.post('shipment/save-import-shipment-record', formData);
            console.log('API Response:', res.data);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg)
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
        loadDetails(selectedRowData.id)
    }

    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    //   Upload
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);


    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    //   Upload


    const AddRecords = () => {
        localStorage.removeItem('SHEdit');
        localStorage.setItem('ccbackUrl', '/ForwarderShipments/ShipmentRecords');
        localStorage.setItem('AddShipmentType', 'import');
        history.push('/ForwarderShipments/AddShipmentRecords');
    }

    const openConf = () => {
        if (gridSelect.length > 0) {
            setShowConfirmation(true);
            setConfirmationInfo('D')
        } else {
            toast.error('Please select Shipment first')
        }
    }

    const handleShowConfirmation = (deleteFunction) => {
        setShowConfirmation(true);
        setDeleteFunction(() => deleteFunction);
    };
    const handleConfirmDelete = () => {
        deleteRow();
        // deleteFunction(deleteId)
        setShowConfirmation(false);
    };

    const handleCancelDelete = () => {
        setDeleteId('')
        setShowConfirmation(false);
    };
    const deleteRow = async (selectedId) => {
        // console.log('selectedId', selectedId);
        const ids = gridSelect?.map(data => data.id)

        try {
            const res = await withRFSToken.post('shipment/active-inactive-record', { tab: 'import', id: ids, status: 'D' });
            if (res.data.response_code == 200) {
                toast.success('User Data Removed Successfully')
                // fetchData();
                gridSelect.forEach(item => {
                    const selectedRowBoundIndex = item.boundindex;
                    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                });
                setGridSelect([]);
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                setDeleteId('');
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    // active archive

    const handleMoveToActArc = (info) => {
        if (gridSelect.length <= 0) {
            toast.error('Please select Shipment first');
        } else {
            setShowConfirmation(true);
            setConfirmationInfo(info)
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {
        // console.log('101', gridSelect);
        const sendAction = (activeTab === 'Active' || activeTab === 'Nvwa') ? 'I' : 'A';
        const ids = gridSelect?.map(data => data.id)
        try {
            const res = await withRFSToken.post('shipment/active-inactive-record', { tab: 'import', status: sendAction, id: ids })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        setShowConfirmation(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // Modal for Asset Type and Cancel

    const [showModal, setShowModal] = useState(false);
    const [modalRadioValue, setModalRadioValue] = useState('');
    const [modalContent, setModalContent] = useState('');
    const handleModalClose = () => { setShowModal(false); setModalRadioValue(''); setFileName(''); };

    const handleModalOpen = (contentType) => {
        setModalContent(contentType);
        setShowModal(true);
    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            setShowModal(false);
            history.push('/ULDControl');
        } else {
            setShowModal(false);
        }
    }

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState('');

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);

        const input = event.target;
        console.log("🚀 ~ handleFileChange ~ input:", input.files)
        if (input.files && input.files[0]) {
            const file = input.files[0];
            setFileName(file.name);
            setSelectedFile(file);
        }
    };

    const exportToExcel = async () => {
        try {
            const res = await withRFSToken.post("shipment/download-shipment-record", { tab: activeTab },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    responseType: 'blob',
                }
            )
                .then(response => {
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${activeTab} - ${formattedDateTime} Downloaded`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);

    };
    

    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file first!");
            return;
        }

        if (selectedFile) {

            try {
                const formData = new FormData();
                formData.append("excel_file", selectedFile);
                // console.log("🚀 ~ handleUpload ~ selectedFile:", formData)
                // console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)

                const res = await withRFSToken.post(
                    'shipment/import-shipment-record',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                // const res = await withRFSToken.post('shipment/import-shipment-record', formData,{
                //     headers: {
                //         'Content-Type': 'multipart/form-data'
                //         }
                // });
                // .then(function (res) {
                if (res.data.response_code == 200) {
                    setGridSelect([]);
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setFileName('');
                    toast.success(res.data.response_msg);                    
                    setShowModal(false);
                } else { toast.error(res.data.response_msg) }
                // });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const handleDownloadClick = () => {
        const a = document.createElement('a');
        a.href = XLSFILE;
        a.download = 'Import_template.xls'; // Name for the downloaded file
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };
    // Modal for End Asset Type and Cancel

    return (
        <>
            {downloadOpen && <DownloadGrid download_sec={activeTab} onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <button className="addtruck me-2" variant="primary" onClick={AddRecords}>
                        <span> <FontAwesomeIcon icon={faPlus} />  Add Shipment</span>
                    </button>
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleModalOpen('import')} >Upload Data</Dropdown.Item>
                            <Dropdown.Item onClick={() =>handleMoveToActArc((activeTab === 'Active' || activeTab === 'Nvwa') ? 'R' : 'A')}>
                                {(activeTab === 'Active' || activeTab === 'Nvwa') ? 'Archive' : 'Active'}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <div className='ulddown'>
                    <button onClick={() => activeTab !== 'Nvwa' ? exportToExcel() : showDownloadModal()}>
                        <img src={Export} alt="export" /> Download
                    </button>
                    
                    {/* <button onClick={() => handleMoveToActArc((activeTab === 'Active' || activeTab === 'Nvwa') ? 'R' : 'A')}>
                        <img 
                            src={(activeTab === 'Active' || activeTab === 'Nvwa') ? Arcv : Activ} 
                            alt="" 
                        /> 
                        {(activeTab === 'Active' || activeTab === 'Nvwa') ? 'Archive' : 'Active'}
                    </button> */}
                        {/* <button onClick={() => activeTab !== 'Nvwa' ? exportToExcel() : showDownloadModal()}>
                            <img src={Export} alt="export" /> Download
                        </button>
                        <button onClick={() => handleMoveToActArc(activeTab === 'Active' ? 'R' : 'A')}>
                            <img title='' src={activeTab === 'Active' ? Arcv : Activ} /> {activeTab === 'Active' ? 'Archive' : 'Active'}
                        </button> */}
                        {/* {activeTab !== 'Trash' && <button onClick={openConf}> <img title='' src={trash} /> Trash </button>} */}
                    </div>
                </div>
            </div>
            <div className="maindiv">
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Nvwa" title={<span>NVWA Planning</span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Nvwa} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archive</span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Trash} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                    {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.cargohub_id} &nbsp; <span></span>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                            </div>
                        </div>
                        <div className='update_info'>
                            <div className='d-flex justify-content-between align-items-center MB-2'>
                                <h4>Update Status</h4>
                                {editMode ?
                                    <Link to='#' onClick={handleEditSubmit}><FontAwesomeIcon icon={faCircleCheck} /></Link>
                                    :
                                    <Link to='#' onClick={handleDetailsEdit}><FontAwesomeIcon icon={faPencil} /></Link>
                                }
                            </div>
                            {console.log('formData', formData)}
                            <ul>
                                <li>
                                    <span>Assigned User :</span>
                                    <span>
                                        {editMode ?
                                            <Form.Group className="my-2">
                                                <Select
                                                    options={userList}
                                                    onChange={(selected) => {
                                                        setFormData({
                                                            ...formData,
                                                            assigned_to: selected.value
                                                        });
                                                    }}
                                                    placeholder="User"
                                                    className='autoslct w-100'
                                                    name="assigned_to"
                                                    value={formData.assigned_to
                                                        ? userList.find(option => option.value === formData.assigned_to)
                                                        : null}
                                                />
                                            </Form.Group>
                                            :
                                            <>{selectedRowData?.assigned_user ? selectedRowData?.assigned_user?.first_Name + ' ' + selectedRowData?.assigned_user?.last_Name : ''}</>
                                        }
                                    </span>

                                </li>
                                <li>
                                    <span>Status :</span>
                                    <span>
                                        {editMode ?
                                            <Form.Group className="my-2">
                                                <Select
                                                    options={statusList}
                                                    onChange={(selected) => {
                                                        setFormData({
                                                            ...formData,
                                                            setting_status: selected.value
                                                        });
                                                    }}
                                                    placeholder="Status"
                                                    className='autoslct w-100'
                                                    name="setting_status"
                                                    value={formData.setting_status
                                                        ? statusList.find(option => option.value === formData?.setting_status?.id)
                                                        : null}
                                                />
                                            </Form.Group>
                                            :
                                            <>{selectedRowData?.setting_status?.name}</>
                                        }
                                    </span>
                                </li>
                                <li>
                                    <span>Department :</span>
                                    <span>
                                        {editMode ?
                                            <Form.Group className="my-2">
                                                <Select
                                                    options={departmentList}
                                                    onChange={(selected) => {
                                                        setFormData({
                                                            ...formData,
                                                            setting_department: selected.value
                                                        });
                                                    }}
                                                    placeholder="Department"
                                                    className='autoslct w-100'
                                                    name="setting_department"
                                                    value={formData.setting_department
                                                        ? departmentList.find(option => option.value === formData?.setting_department?.id)
                                                        : null}
                                                />
                                            </Form.Group>
                                            :
                                            <>{selectedRowData?.setting_department?.name}</>
                                        }
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {/* {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => (
                                              <li key={index}>
                                                <span className='movem'>{history.operation_type}</span> <span className='mvdate'>{history.operation_date}</span>
                                                <Link to="#" onClick={() => handleDetailsClick(history)}>Details</Link>
                                              </li>
                                            ))} */}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"imp_shipment_record"}
                            attachable_id={selectedRowData.id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.id)}
                        />
                        <ActivityComments
                            commentable_type={"imp_shipment_record"}
                            commentable_id={selectedRowData.id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.id)}
                        />
                    </div>
                )}
            </div>
            <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>{confirmationInfo == 'D' ? 'Confirm Delete' : `Selected ${gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}</h2>
                    <p>If you proceed with the change, user data will be {confirmationInfo == 'D' ? 'removed' : `moved to ${activeTab == 'Active' ? 'Archive' : 'Active'}`}.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelDelete}>
                        No
                    </Button>
                    <Button variant="primary" onClick={confirmationInfo == 'D' ? handleConfirmDelete : confirmMoveToActArc}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* shipment import */}

            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {modalContent === 'import' && (
                        <>
                            <h3>Import Excel</h3>
                            <p>Upload the filled in template to add ULDs.</p>
                            <div className='asset_midle'>

                                <div className='upload_tmpl'>
                                    <button onClick={handleDownloadClick}>
                                        <FontAwesomeIcon icon={faDownload} />
                                        <span>Download Template (Excel) </span>
                                    </button>
                                    <div className="form-group inputDnD">
                                        <FontAwesomeIcon icon={faUpload} />
                                        <input
                                            type="file" className="form-control-file "
                                            id="inputFile"
                                            // accept=".xlsx, .xls, .csv"
                                            onChange={handleFileChange}
                                            data-title="Upload your file (Excel)" />

                                        {/* {fileData && (
                                                            <div>
                                                                <h4>File Data:</h4>
                                                                <pre>{fileData}</pre>
                                                            </div>
                                                        )} */}
                                    </div>
                                </div>
                                {console.log('fileName', fileName)}
                                {fileName && (
                                    <div className='rafilname'>
                                        <p>File Name: {fileName}</p>
                                    </div>
                                )}


                            </div>
                        </>
                    )}

                    {modalContent === 'cancelForm' && (
                        <>
                            <h3>All changes will be destroyed. </h3>
                            <p>If you proceed with the change, all data in this section will be removed.
                                Are you sure you want to continue?</p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <>
                        <div className='d-flex w-50 mx-auto are_bottom'>
                            <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={handleUpload}>
                                Upload
                            </Button>
                        </div>
                    </>

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RecordImport